export const invoicesTranslations = {
  ar: {
    title: 'فاتورة بيع',
    addNew: 'جديد',
    branch: 'الفرع',
    store: 'المخزن',
    customer: 'العميل',
    date: 'التاريخ',
    deliveryDate: 'تاريخ التسليم',
    referenceNumber: 'رقم المرجع',
    paymentMethod: 'طريقة الدفع',
    cashAccount: 'حساب الخزينة',
    shippingAddress: 'عنوان الشحن',
    driver: 'السائق',
    recipientData: 'بيانات المستلم',
    approvedBy: 'اعتمد بواسطة',
    createdBy: 'انشأ بواسطة',
    barcode: 'الباركود',
    priceType: 'نوع السعر',
    availableQuantity: 'الكمية المتاحة',
    lastPriceForCustomer: 'اخر سعر للعميل',
    product: 'المنتج',
    unit: 'الوحدة',
    quantity: 'الكمية',
    price: 'السعر',
    giftItem: 'صنف هدية',
    percentageDiscount: 'خصم نسبة',
    cashDiscount: 'خصم نقدى',
    netBeforeTax: 'الصافي قبل الضريبة',
    net: 'الصافي',
    add: 'اضافة',
    modify: 'تعديل',
    delete: 'حذف',
    totalDiscount: 'الخصم الكلى',
    additions: 'اضافات',
    totalTax: 'الضريبة الكلية',
    total: 'الاجمالي',
    advance: 'المقدم',
    finalNet: 'الصافي النهائي',
    customerDebtBefore: 'مديونية العميل قبل',
    customerDebtAfter: 'مديونية العميل بعد',
    notes: 'ملاحظات',
    save: 'حفظ',
    financialApproval: 'إعتماد مالي',
    approve: 'اعتماد',
    printDesign: 'طباعة تصميم',
    design: 'تصميم',
    clearFields: 'تفريغ الحقول',
    sync: 'SYNC',
    noInvoices: 'لا توجد فواتير',
    loading: 'جاري تحميل الفواتير...',
    error: 'فشل تحميل الفواتير',
    saveSuccess: 'تم حفظ الفاتورة بنجاح',
    saveError: 'فشل حفظ الفاتورة',
    deleteSuccess: 'تم حذف الفاتورة بنجاح',
    deleteError: 'فشل حذف الفاتورة',
    selectBranch: 'اختر الفرع',
    selectStore: 'اختر المخزن',
    selectCustomer: 'اختر العميل',
    selectPaymentMethod: 'اختر طريقة الدفع',
    selectCashAccount: 'اختر حساب الخزينة',
    selectItem: 'اختر المنتج',
    selectUnit: 'اختر الوحدة',
    selectTax: 'اختر الضريبة',
    noDataToDisplay: 'لا توجد بيانات للعرض',
    serial: 'الرقم التسلسلي',
    invoiceSerial: 'رقم الفاتورة',
    totalAmount: 'المبلغ الإجمالي',
    taxType: 'نوع الضريبة',
    grossTotal: 'الإجمالي قبل الخصم',
    firstPaid: 'المدفوع',
    additionals: 'إضافات',
    userRefNo: 'رقم المرجع',
    actions: 'الإجراءات',
    print: 'طباعة',
    view: 'عرض',
    edit: 'تعديل',
    return: 'إرجاع',
    scan: 'مسح',
    salesRep: 'المندوب',
    sellingCurrency: 'عملة البيع',
    exchangeRate: 'سعر الصرف',
  },
  en: {
    title: 'Sales Invoice',
    addNew: 'New Invoice',
    branch: 'Branch',
    store: 'Warehouse',
    customer: 'Customer',
    date: 'Date',
    deliveryDate: 'Delivery Date',
    referenceNumber: 'Reference Number',
    paymentMethod: 'Payment Method',
    cashAccount: 'Treasury Account',
    shippingAddress: 'Shipping Address',
    driver: 'Driver',
    recipientData: 'Recipient Data',
    approvedBy: 'Approved by',
    createdBy: 'Created by',
    barcode: 'Barcode',
    priceType: 'Price Type',
    availableQuantity: 'Available Quantity',
    lastPriceForCustomer: 'Last Price for Customer',
    product: 'Product',
    unit: 'Unit',
    quantity: 'Quantity',
    price: 'Price',
    giftItem: 'Gift Item',
    percentageDiscount: 'Percentage Discount',
    cashDiscount: 'Cash Discount',
    netBeforeTax: 'Net Before Tax',
    net: 'Net',
    add: 'Add',
    modify: 'Modify',
    delete: 'Delete',
    totalDiscount: 'Total Discount',
    additions: 'Additions',
    totalTax: 'Total Tax',
    total: 'Total',
    advance: 'Advance',
    finalNet: 'Final Net',
    customerDebtBefore: 'Customer Debt Before',
    customerDebtAfter: 'Customer Debt After',
    notes: 'Notes',
    save: 'Save',
    financialApproval: 'Financial Approval',
    approve: 'Approve',
    printDesign: 'Print Design',
    design: 'Design',
    clearFields: 'Clear Fields',
    sync: 'SYNC',
    noInvoices: 'No invoices',
    loading: 'Loading invoices...',
    error: 'Failed to load invoices',
    saveSuccess: 'Invoice saved successfully',
    saveError: 'Failed to save invoice',
    deleteSuccess: 'Invoice deleted successfully',
    deleteError: 'Failed to delete invoice',
    selectBranch: 'Select Branch',
    selectStore: 'Select Store',
    selectCustomer: 'Select Customer',
    selectPaymentMethod: 'Select Payment Method',
    selectCashAccount: 'Select Cash Account',
    selectItem: 'Select Item',
    selectUnit: 'Select Unit',
    selectTax: 'Select Tax',
    noDataToDisplay: 'No data to display',
    serial: 'Serial',
    invoiceSerial: 'Invoice Serial',
    totalAmount: 'Total Amount',
    taxType: 'Tax Type',
    grossTotal: 'Gross Total',
    firstPaid: 'Paid',
    additionals: 'Additionals',
    userRefNo: 'Reference No.',
    actions: 'Actions',
    print: 'Print',
    view: 'View',
    edit: 'Edit',
    return: 'Return',
    scan: 'Scan',
    salesRep: 'Sales representative',
    sellingCurrency: 'Selling currency',
    exchangeRate: 'Exchange rate',
  },
  fr: {
    title: 'Facture de vente',
    addNew: 'Nouvelle facture',
    branch: 'Succursale',
    store: 'Entrepôt',
    customer: 'Client',
    date: 'Date',
    deliveryDate: 'Date de livraison',
    referenceNumber: 'Numéro de référence',
    paymentMethod: 'Méthode de paiement',
    cashAccount: 'Compte de trésorerie',
    shippingAddress: 'Adresse de livraison',
    driver: 'Chauffeur',
    recipientData: 'Données du destinataire',
    approvedBy: 'Approuvé par',
    createdBy: 'Créé par',
    barcode: 'Code-barres',
    priceType: 'Type de prix',
    availableQuantity: 'Quantité disponible',
    lastPriceForCustomer: 'Dernier prix pour le client',
    product: 'Produit',
    unit: 'Unité',
    quantity: 'Quantité',
    price: 'Prix',
    giftItem: 'Article cadeau',
    percentageDiscount: 'Remise en pourcentage',
    cashDiscount: 'Remise en espèces',
    netBeforeTax: 'Net avant taxes',
    net: 'Net',
    add: 'Ajouter',
    modify: 'Modifier',
    delete: 'Supprimer',
    totalDiscount: 'Remise totale',
    additions: 'Ajouts',
    totalTax: 'Taxe totale',
    total: 'Total',
    advance: 'Acompte',
    finalNet: 'Net final',
    customerDebtBefore: 'Dette client avant',
    customerDebtAfter: 'Dette client après',
    notes: 'Notes',
    save: 'Enregistrer',
    financialApproval: 'Approbation financière',
    approve: 'Approuver',
    printDesign: 'Imprimer le design',
    design: 'Design',
    clearFields: 'Effacer les champs',
    sync: 'SYNC',
    noInvoices: 'Aucune facture',
    loading: 'Chargement des factures...',
    error: 'Échec du chargement des factures',
    saveSuccess: 'Facture enregistrée avec succès',
    saveError: 'Échec de l\'enregistrement de la facture',
    deleteSuccess: 'Facture supprimée avec succès',
    deleteError: 'Échec de la suppression de la facture',
    selectBranch: 'Sélectionner la succursale',
    selectStore: 'Sélectionner l\'entrepôt',
    selectCustomer: 'Sélectionner le client',
    selectPaymentMethod: 'Sélectionner la méthode de paiement',
    selectCashAccount: 'Sélectionner le compte de trésorerie',
    selectItem: 'Sélectionner l\'article',
    selectUnit: 'Sélectionner l\'unité',
    selectTax: 'Sélectionner la taxe',
    noDataToDisplay: 'Aucune donnée à afficher',
    serial: 'Série',
    invoiceSerial: 'Numéro de facture',
    totalAmount: 'Montant total',
    taxType: 'Type de taxe',
    grossTotal: 'Total brut',
    firstPaid: 'Payé',
    additionals: 'Ajouts',
    userRefNo: 'Numéro de référence',
    actions: 'Actions',
    print: 'Imprimer',
    view: 'Voir',
    edit: 'Modifier',
    return: 'Retour',
    scan: 'Scanner',
    salesRep: 'Représentant commercial',
    sellingCurrency: 'Devise de vente',
    exchangeRate: 'Taux de change',
  },
}


